<!--  -->
<template>
  <div class="add_box">
    <div class="dawwrq search_box">
      <el-input
        v-model="query.keywords"
        placeholder="请输入标题"
        style="width: 400px;"
      />
      <el-select v-model="query.onlyMe" placeholder="请选择" style="margin-left:10px">
        <el-option
          v-for="item in accountarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="info"
        icon="el-icon-refresh-right"
        @click="reset"
      >重置</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >

      <el-table-column
        align="center"
        prop="title"
        label="自有标题"
        width="200"
      >
        <template slot-scope="scope">
          <div class="sedrtw">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="content"
        label="发送的文本"
        width="400"
      >
        <template slot-scope="scope">
          <div class="sedrtwr">{{ scope.row.content }}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at_text"
        label="创建时间"
        width="180"
      />
      <el-table-column
        align="center"
        prop="realName"
        label="创建人"
        width="100"
      />
      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="chooser(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { momentsmomentsList } from '@/api/officialaccount.js'
export default {
  name: 'Domainname',
  components: {
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      total: null,
      adtype: null,
      query: {
        page: 1,
        page_size: 10,
        keywords: '',
        onlyMe: 2
      },
      tableData: [],
      accountarr: [{
        value: 1,
        label: '查看组内'
      }, {
        value: 2,
        label: '我关联的'
      }]
    }
  },
  created() {
    this.menuList()
  },
  mounted() {},
  methods: {
    async menuList() {
      // 获取列表
      const data = await momentsmomentsList(this.query)
      console.log('data', data)
      this.tableData = data.data.list
      this.total = data.data.total
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.menuList()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    chooser(item) {
      console.log(item)
      this.$emit('friendband', item)
    },
    // 搜索
    search() {
      this.query.page = 1
      this.menuList()
    },

    // 重置
    reset() {
      this.query.page = 1
      this.query.page_size = 10
      this.query.keywords = ''
      this.menuList()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.sarch_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sedrtw {
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
.sedrtwr {
  width: 380px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
.dawwrq {
  display: flex;
  align-items: center;
}
</style>
